<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 200px; background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-primary opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">Hello {{loggedInUser.name}}</h1>
                        <p class="text-white mt-0 mb-5">Here you can view the users in your network, as well as manage their zones and roles.</p>
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <div class="row">
                        <div class="col">
                            <card shadow type="white">
                                <div slot="header" class="bg-white border-0">
                                    <div class="row align-items-center">
                                        <div class="col-8">
                                            <h3 class="mb-0">Users</h3>
                                        </div>
                                        <div class="col-4 text-right">
                                            <base-button size="sm" type="success" @click="addUser">Add User</base-button>
                                        </div>
                                    </div>
                                </div>
                                <template>
                                    <div class="table-responsive">
                                        <b-table class="table-responsive align-items-center table-flush"
                                                    striped
                                                    thread-classes="thead-light"
                                                    tbody-classes="list"
                                                    :items="users"
                                                    :fields="userColumns"
                                                    @row-clicked="selectedRow">
                                        </b-table>
                                    </div>
                                </template>
                            </card>
                        </div>
                    </div>

                    <b-row>
                        <b-col>
                            <card shadow type="white" v-show="addUserVisible">
                                <template v-slot:header class="bg-white">
                                    <b-row align-v="center">
                                        <b-col cols="8">
                                            <h3 class="mb-0">Add Account</h3>
                                        </b-col>
                                        <b-col cols="4" class="text-right">
                                            <base-button size="sm" type="warning" @click="clearNewUser">Clear</base-button>
                                            <base-button size="sm" type="success" @click="addUser">Submit</base-button>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template v-slot:default>
                                    <form @submit.prevent>
                                        <h6 class="heading-small text-muted mb-4">Add User Information:</h6>
                                        <div class="pl-lg-4">
                                            <b-row>
                                                <b-col cols="6">
                                                    <base-input alternative=""
                                                                label="Name"
                                                                placeholder=""
                                                                input-classes="form-control-alternative"
                                                                v-model="newUser.name"></base-input>
                                                </b-col>
                                                <b-col cols="6">
                                                    <base-input alternative=""
                                                                label="Email"
                                                                placeholder=""
                                                                input-classes="form-control-alternative"
                                                                v-model="newUser.email"></base-input>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <div class="col-lg-6">
                                                    <base-input alternative=""
                                                                label="Zones"
                                                                placeholder=""
                                                                input-classes="form-control-alternative"
                                                                v-model="newUser.zones" />
                                                </div>
                                                <div class="col-lg-6">
                                                    <base-input alternative=""
                                                                label="Roles"
                                                                placeholder="None"
                                                                input-classes="form-control-alternative"
                                                                v-model="newUser.roles" />
                                                </div>

                                            </b-row>
                                        </div>
                                    </form>
                                </template>
                            </card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <card shadow type="white" v-show="editUser.name.length>0">
                                <template v-slot:header class="bg-white border-0">
                                    <b-row align-v="center">
                                        <b-col cols="8">
                                            <h3 class="mb-0">Edit account</h3>
                                        </b-col>
                                        <b-col cols="4" class="text-right">
                                            <base-button size="sm"
                                                         type="warning"
                                                         @click="clearEditUser">Clear</base-button>
                                            <base-button size="sm"
                                                         type="success"
                                                         @click="updateUser">Submit</base-button>
                                        </b-col>
                                    </b-row>
                                </template>
                                <template v-slot:default>
                                    <form @submit.prevent>
                                        <h6 class="heading-small text-muted mb-4">
                                            Edit User Information:<br />
                                            {{editUser.name}} - {{editUser.email}}
                                        </h6>
                                        <div class="pl-lg-4">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <base-input alternative=""
                                                                label="Zones"
                                                                placeholder=""
                                                                input-classes="form-control-alternative"
                                                                v-model="editUser.zones" />
                                                </div>
                                                <div class="col-lg-6">
                                                    <base-input alternative=""
                                                                label="Roles"
                                                                placeholder="None"
                                                                input-classes="form-control-alternative"
                                                                v-model="editUser.roles" />
                                                </div>

                                            </div>
                                        </div>
                                    </form>
                                </template>
                            </card>
                        </b-col>
                    </b-row>
                </div>

                <!--<div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img src="img/theme/team-4-800x800.jpg" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <div class="d-flex justify-content-between">
                                <base-button size="sm" type="info" class="mr-4">Connect</base-button>
                                <base-button size="sm" type="default" class="float-right">Message</base-button>
                            </div>
                        </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description">Friends</span>
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description">Photos</span>
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description">Comments</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                    Jessica Jones<span class="font-weight-light">, 27</span>
                                </h3>
                                <div class="h5 font-weight-300">
                                    <i class="ni location_pin mr-2"></i>Bucharest, Romania
                                </div>
                                <div class="h5 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
                                </div>
                                <div>
                                    <i class="ni education_hat mr-2"></i>University of Computer Science
                                </div>
                                <hr class="my-4" />
                                <p>Ryan — the name taken by Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs and records all of his own music.</p>
                                <a href="#">Show more</a>
                            </div>
                        </div>
                    </div>
                </div>-->

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'user-profile',
        data() {
            return {
                users: [],
                userColumns: [
                    { key: 'email', sortable: true },
                    { key: 'name', sortable: true },
                    { key: 'roles', sortable: true },
                    { key: 'zones', sortable: true }
                ],
                loggedInUser: {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                    company: ''
                },
                editUser: {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                },
                newUser: {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                },
                addUserVisible: false,
            }
        },
        mounted() {
            this.getUserList();
            this.$Amplify.Auth.currentUserInfo()
                .then(data => {
                    if (data) {
                        
                        this.loggedInUser.username = data.username;
                        this.loggedInUser.email = data.attributes.email;
                        this.loggedInUser.name = data.attributes.name;
                        this.loggedInUser.roles = data.attributes["custom:Roles"];
                        this.loggedInUser.zones = data.attributes["custom:Zones"];
                        this.loggedInUser.company = data.attributes["custom:Company"]
                    } else {
                        this.loggedInUser.username = '';
                        this.loggedInUser.email = '';
                        this.loggedInUser.name = '';
                        this.loggedInUser.roles = '';
                        this.loggedInUser.zones = '';
                    }
                });
        },
        methods: {
            getUserList() {
                this.axios.get('Users/list')
                    .then(response => {
                        this.users = response.data;
                    })
                    .catch(error => {
                        
                        this.users = [];
                    })
                    .finally(() => {
                        // final cleanup
                    });
            },
            clearEditUser() {
                this.editUser = {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                };
            },
            clearNewUser() {
                this.newUser = {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                };
                this.addUserVisible = false;
            },
            selectedRow(user) {
                
                this.editUser = user;
            },
            updateUser() {
                this.axios.post('Users/update', this.editUser)
                    .then(response => {
                    })
                    .catch(error => {
                        
                    })
                    .finally(() => {
                        this.clearEditUser();
                    });
            },
            addUser() {
                if (!this.addUserVisible) {
                    this.addUserVisible = true;
                    return;
                }
                this.axios.post('Users/create', this.newUser)
                    .then(response => {
                        this.clearNewUser();
                    })
                    .catch(error => {
                        
                    })
                    .finally(() => {
                        // finish up always
                        this.getUserList();
                    });
            },
        },
    };
</script>
<style></style>
